"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackNextButtonClick = trackNextButtonClick;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _analytics = require("@cian/analytics");
var _tracking = require("../../../../../utils/tracking");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function trackNextButtonClick(_ref) {
  let {
    licenceAccepted,
    marketingSubscriptionAccepted,
    source
  } = _ref;
  const labelsRaw = [];
  if (licenceAccepted) {
    labelsRaw.push('terms');
  }
  if (marketingSubscriptionAccepted) {
    labelsRaw.push('ads');
  }
  (0, _analytics.ca)('eventSite', _objectSpread({
    name: 'oldevent',
    category: 'UserAgreement',
    action: 'click_continue',
    label: labelsRaw.join('_')
  }, source && {
    page: _objectSpread(_objectSpread({}, (0, _tracking.getCianAnalyticsObjectPage)()), {}, {
      extra: {
        source
      }
    })
  }));
}